/**
 * Work with the notification queue.
 */
import type { ActionContext } from 'js/lib/ActionContext';

import { EVENT_NAMES } from '../constants';
import type { NotificationData } from '../types';

/** Empty the queue of notifications. */
export const clear = (
  /** Provided by fluxible. */
  actionContext: ActionContext
): void => {
  actionContext.dispatch(EVENT_NAMES.NOTIFICATIONS, []);
};

/** Shift a notification off the front of the queue. */
export const dequeue = (
  /** Provided by fluxible. */
  actionContext: ActionContext
): void => {
  const notifications = actionContext.getStore('StaffManagementStoreV2').notifications().slice();
  notifications.shift();
  actionContext.dispatch(EVENT_NAMES.NOTIFICATIONS, notifications);
};

/** Add a notification to the end of the queue. */
export const enqueue = (
  /** Provided by fluxible. */
  actionContext: ActionContext,
  /**
   * Add a notification to the notification queue.
   * If string, it becomes the message of a notification with default type.
   */
  notification: string | NotificationData
): void => {
  const notificationObject = typeof notification === 'string' ? { message: notification } : notification;
  const notifications = actionContext.getStore('StaffManagementStoreV2').notifications().slice();
  notifications.push(notificationObject);
  actionContext.dispatch(EVENT_NAMES.NOTIFICATIONS, notifications);
};
